import { useState } from 'react'
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material'
import { StepperModel } from '../../../app/models/Stepper'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string
  isOpen: boolean
  handleClose: () => void
  info: StepperModel[]
}

const StepperComponent = ({ isOpen, handleClose, title, info }: Props) => {
  const [activeStep, setActiveStep] = useState(0)
  const { t } = useTranslation()

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const steps = info.map((_, index) => `Step ${index + 1}`)

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth='md' fullWidth={true}>
      <DialogTitle>
        <Container>
          <h1 className='text-center'>{title}</h1>
        </Container>
      </DialogTitle>
      <DialogContent>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div>
            {info.map(
              (stepInfo, index) =>
                activeStep === index && (
                  <div key={index}>
                    <div className='d-flex justify-content-center align-items-center pt-3'>
                      {stepInfo.video && (
                        <video className='video' height='auto' autoPlay loop muted>
                          <source src={stepInfo.video} type='video/mp4' />
                          Your browser does not support the video tag.
                        </video>
                      )}
                    </div>
                    <div className='text-center pt-2'>{stepInfo.description}</div>
                  </div>
                ),
            )}
          </div>
        </div>
      </DialogContent>
      <DialogActions className='d-flex justify-content-between'>
        <Button onClick={handleClose}>{t('close')}</Button>
        <div>
          <Button disabled={activeStep === 0} onClick={handleBack}>
            {t('go_back')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleNext}
            className='ms-2'
            disabled={activeStep === steps.length - 1}
          >
            {t('next')}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default StepperComponent
